import React from 'react';
import type { ReactElement } from 'react';
import { H4, Divider, spacingHelper, Stack } from '@construct-kit/core';
import styled from 'styled-components';

type FilterWrapperProps = {
  title: string;
  showDivider?: boolean;
  children: ReactElement;
  hideHeading?: boolean;
};

const StyledDivider = styled(Divider)`
  margin: ${spacingHelper('extraLarge 0 0 0')};
`;

export const FilterWrapper = ({
  title,
  children,
  showDivider = true,
  hideHeading = false,
}: FilterWrapperProps): ReactElement => (
  <Stack inset="large large 0 large" gap="0">
    {!hideHeading && <H4>{title}</H4>}
    {children}
    {showDivider && <StyledDivider />}
  </Stack>
);
